<div
  class="sidebar-menu-overlay"
  [class.sidebar-menu-overlay-visible]="isMenuOpened()"
  (click)="closeMenu()"
>
  <div class="sidebar-menu-overlay-close">
    <i class="mbi mbi-arrow-left sidebar-menu-overlay-close-icon"></i>
  </div>
</div>

<div
  class="sidebar-menu-panel"
  [class.sidebar-menu-panel-visible]="isMenuOpened()"
>
  <div class="sidebar-menu-content">
    <a
      class="sidebar-menu-logo sidebar-menu-section"
      routerLink="/"
      routerLinkWithLang
      (click)="closeMenu()"
    >
      <img
        class="sidebar-menu-logo-img"
        src="../../../../assets/images/logo.png"
        alt="Klondike"
        loading="lazy"
      >
    </a>

    <div class="sidebar-menu-section">
      @if (customerService.isLoggedIn()) {
        <a
          class="sidebar-menu-link"
          routerLink="/account"
          routerLinkWithLang
          (click)="closeMenu()"
        >
          <i class="sidebar-menu-link-icon mbi mbi-user"></i>
          <div class="sidebar-menu-link-label">
            {{ customerService.customerName() || ('global.my_account' | translate) }}
          </div>
        </a>
      } @else {
        <div
          class="sidebar-menu-link"
          (click)="showLogin()"
        >
          <i class="sidebar-menu-link-icon mbi mbi-user"></i>
          <div class="sidebar-menu-link-label">
            {{ 'sidebar_menu.login' | translate }}
          </div>
        </div>
      }
    </div>

    <div class="sidebar-menu-lang sidebar-menu-section">
      <div class="sidebar-menu-lang-label">
        {{ 'sidebar_menu.lang' | translate }}
      </div>

      <lang-selector
        class="sidebar-menu-lang-selector"
        [isInSidebar]="true"
      />
    </div>

    <div class="sidebar-menu-section">
      <button
        class="sidebar-menu-link"
        type="button"
        aria-haspopup="dialog"
        (click)="isCatalogOpened.set(true)"
      >
        <tc-icon class="sidebar-menu-link-icon" name="catalog" />
        <div class="sidebar-menu-link-label">
          {{ 'sidebar_menu.catalog' | translate }}
        </div>
      </button>

      @if (customerService.isLoggedIn()) {
        <a
          class="sidebar-menu-link"
          (click)="closeMenu()"
          routerLink="/account/orders"
          routerLinkWithLang
        >
          <tc-icon class="sidebar-menu-link-icon" name="orders" />
          <div class="sidebar-menu-link-label">
            {{ 'global.my_orders' | translate }}
          </div>
        </a>
      } @else {
        <div
          class="sidebar-menu-link"
          (click)="showLogin()"
        >
          <tc-icon class="sidebar-menu-link-icon" name="orders" />
          <div class="sidebar-menu-link-label">
            {{ 'global.my_orders' | translate }}
          </div>
        </div>
      }

      <div
        class="sidebar-menu-link sidebar-menu-link-cart"
        (click)="showCart()"
      >
        <tc-icon
          class="sidebar-menu-link-icon"
          name="cart"
        />
        <div class="sidebar-menu-link-label">
          {{ 'global.cart' | translate }}
        </div>
        @if (cartService.cartItems().length) {
          <div class="sidebar-menu-link-count">
            {{ cartService.cartItems().length }}
          </div>
        }
      </div>

      <a
        class="sidebar-menu-link"
        routerLink="/wishlist"
        routerLinkWithLang
        (click)="closeMenu()"
      >
        <tc-icon
          class="sidebar-menu-link-icon"
          name="heart"
        />
        <span class="sidebar-menu-link-label">
          {{ 'global.my_wishes' | translate }}
        </span>
        @if (wishlistService.wishlistProductIds().length) {
          <div class="sidebar-menu-link-count">
            {{ wishlistService.wishlistProductIds().length }}
          </div>
        }
      </a>
    </div>

    <div class="sidebar-menu-section">
      @for (phoneNumber of MANAGER_PHONES; track phoneNumber) {
        <a
          class="sidebar-menu-phone"
          [href]="'tel:' + phoneNumber"
        >
          {{ phoneNumber | mask:PHONE_NUMBER_MASK }}
        </a>
      }
    </div>

    <div class="sidebar-menu-section">
      <service-menu
        class="sidebar-menu-service-menu"
        [isInSidebar]="true"
        layout="vertical"
      />
    </div>

    <div class="sidebar-menu-section sidebar-menu-socials">
      <div class="sidebar-menu-socials-title">
        {{ 'sidebar_menu.in_social' | translate }}
      </div>

      <ul class="sidebar-menu-socials-list">
        <li class="sidebar-menu-socials-item">
          <a
            class="sidebar-menu-socials-link sidebar-menu-socials-link-facebook"
            aria-label="Facebook"
            href="https://facebook.com/klondike.com.ua"
            title="Facebook"
            target="_blank"
          >
            <svg
              class="sidebar-menu-socials-icon"
              aria-hidden="true"
              viewBox="0 0 24 24"
            >
              <path d="m15.6376 11.9807h-2.6695v10.0193h-4.04452v-10.0193h-1.92358v-3.52113h1.92358v-2.27859c0-1.62945.75551-4.18098 4.08052-4.18098l2.9959.01284v3.41789h-2.1737c-.3566 0-.8579.18251-.8579.9598v2.07232h3.0225z" />
            </svg>
          </a>
        </li>

        <li class="sidebar-menu-socials-item">
          <a
            class="sidebar-menu-socials-link sidebar-menu-socials-link-instagram"
            aria-label="Instagram"
            href="https://instagram.com/klondike.com.ua"
            title="Instagram"
            target="_blank"
          >
            <svg
              class="sidebar-menu-socials-icon"
              aria-hidden="true"
              viewBox="0 0 24 24"
            >
              <path d="m21.94 7.87667c-.0489-1.06445-.2178-1.79111-.4644-2.42778-.2556-.65778-.5978-1.21556-1.1534-1.77111-.5555-.55556-1.1133-.89778-1.7711-1.15334-.6367-.24666-1.3633-.41666-2.4278-.46444-1.0666-.04889-1.4077-.06-4.1233-.06-2.71556 0-3.05667.01111-4.12333.06-1.06445.04889-1.79111.21778-2.42667.46444-.65778.25556-1.21556.59778-1.77111 1.15334-.55556.55555-.89778 1.11333-1.15333 1.77111-.24778.63667-.41667 1.36333-.46556 2.42778-.04889 1.06666-.06 1.40777-.06 4.12333 0 2.7156.01111 3.0567.06 4.1233.04889 1.0645.21778 1.7911.46444 2.4278.25556.6578.59778 1.2156 1.15334 1.7711.55555.5567 1.11333.8978 1.77111 1.1534.63667.2477 1.36333.4166 2.42778.4644 1.06666.0489 1.40777.06 4.12333.06 2.7156 0 3.0567-.0122 4.1233-.06 1.0645-.0489 1.7911-.2178 2.4278-.4644.6578-.2556 1.2156-.5978 1.7711-1.1534.5556-.5555.8978-1.1133 1.1534-1.7711.2466-.6355.4166-1.3633.4644-2.4278.0489-1.0666.06-1.4077.06-4.1233 0-2.71556-.0111-3.05667-.06-4.12333zm-1.7878 8.17003c-.0444.9766-.2078 1.5066-.3444 1.86-.1607.4347-.4165.828-.7489 1.1511-.3229.3325-.7163.5884-1.1511.7489-.3534.1377-.8834.3011-1.86.3444-1.0556.0478-1.3722.0589-4.0467.0589-2.67443 0-2.9911-.01-4.04666-.0589-.97666-.0444-1.50666-.2078-1.85999-.3444-.46778-.1811-.80112-.3989-1.15112-.7489s-.56777-.6845-.74889-1.1511c-.13666-.3534-.3-.8834-.34444-1.86-.05-1.0556-.06-1.3723-.06-4.0467 0-2.67444.01-2.99111.05889-4.04667.04444-.97666.20778-1.50666.34444-1.86.18223-.46777.39889-.80111.74889-1.15111.32294-.33249.71628-.58839 1.15111-.74889.35334-.13666.88334-.3 1.86-.34444 1.05556-.04889 1.37223-.06 4.04667-.06 2.6744 0 2.9911.01 4.0467.05889.9766.04444 1.5066.20778 1.86.34444.4677.18222.8011.39889 1.1511.74889s.5678.68445.7489 1.15111c.1366.35334.3.88334.3444 1.86.0478 1.05667.0578 1.37334.0578 4.04668.0011 2.6755-.0089 2.9922-.0567 4.0478zm-8.1522-9.17892c-2.83445 0-5.13222 2.29777-5.13222 5.13222 0 2.8344 2.29777 5.1322 5.13222 5.1322 2.8344 0 5.1322-2.2978 5.1322-5.1322 0-2.83445-2.2978-5.13222-5.1322-5.13222zm0 8.47442c-1.1943 0-2.2978-.6371-2.89493-1.6714-.59713-1.0342-.59713-2.3085 0-3.3427.59713-1.0343 1.70063-1.67143 2.89493-1.67143 1.8462 0 3.3428 1.49663 3.3428 3.34273 0 1.8462-1.4966 3.3428-3.3428 3.3428zm5.3289-9.86887c-.6618 0-1.1983.53652-1.1983 1.19834s.5365 1.19833 1.1983 1.19833 1.1983-.53651 1.1983-1.19833-.5365-1.19834-1.1983-1.19834z" />
            </svg>
          </a>
        </li>
      </ul>
    </div>

    @if (customerService.isLoggedIn()) {
      <button
        class="sidebar-menu-section g-main-link"
        (click)="logout()"
      >
        {{ 'sidebar_menu.logout_from_account' | translate }}
      </button>
    }
  </div>
</div>

<!-- the sidebar closes under the catalog once it has slid in, so closing the catalog shows the page -->
@if (isCatalogOpened()) {
  <catalog-panel
    animate.enter="catalog-panel-enter"
    animate.leave="catalog-panel-leave"
    (shown)="isMenuOpened.set(false)"
    (closed)="closeMenu()"
  />
}
